import React from "react"
import mount from "core/mount"
import { OldButton } from "@kit/design/old-button"
import Note from "@kit/design/note"

function UnconfirmedUserEmailBanner({ emailSettingsLink }) {
  return (
    <Note type="warning" size="sm" className="bg-system-yellow-100!">
      <p className="grow">
        <strong>Confirm your email to finish setting up your account.</strong>{" "}
        We&apos;ve sent a confirmation link to your sign-up address.
      </p>
      <OldButton
        is="plain"
        size="sm"
        href={emailSettingsLink}
        target="_blank"
        className="ml-4 shrink-0 bg-system-yellow-400 hover:bg-system-yellow-500"
      >
        Manage email address
      </OldButton>
    </Note>
  )
}

export { UnconfirmedUserEmailBanner }

mount({ "Account.UnconfirmedUserEmailBanner": UnconfirmedUserEmailBanner })
